import React from 'react';
import { useChatContext } from '../providers/ChatProvider';
import ChatMessage from './ChatMessage';

export default function ChatHistory({ onSendSuggestion }) {
  const { reply } = useChatContext();

  return (
    <div className="space-y-4">
      {reply.map((msg, index) => (
        <ChatMessage
          key={index}
          msg={msg}
          index={index}
          onSendSuggestion={onSendSuggestion}
        />
      ))}
    </div>
  );
}
